"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18n = exports.LocalizationProvider = exports.LocalizationContext = void 0;
var LocalizationContext_1 = require("./LocalizationContext");
Object.defineProperty(exports, "LocalizationContext", { enumerable: true, get: function () { return LocalizationContext_1.LocalizationContext; } });
Object.defineProperty(exports, "LocalizationProvider", { enumerable: true, get: function () { return LocalizationContext_1.LocalizationProvider; } });
var i18n_1 = require("./i18n");
Object.defineProperty(exports, "i18n", { enumerable: true, get: function () { return __importDefault(i18n_1).default; } });
